// This file is generated by a script and should not be modified directly.
const markdown: string =
  "- La base centrale des nomenclatures (BCN) fournie cette date sans l'information de l'heure, nous interprétons arbitrairement l'heure à '00:00:00' sur le fuseau horaire 'Europe/Paris'.\n- La date est retournée au format ISO 8601 avec le fuseau horaire 'Europe/Paris'.\n"
export default markdown
